import {
  isValueArrayNotDuplicate,
  isValueNotEmptyMessage,
  isValueNotLong,
  isValueNotValidSymbol,
  isValueObjectNotDuplicate,
} from '../../../../../../../utils/validators'

const maxSecretNameLength = 300

export const errorMessageNotEmptyField = 'This field must not be empty'

export const validators = [
  {
    validator: isValueNotEmptyMessage,
    message: 'Secret name should not be empty',
  },
  {
    validator: isValueObjectNotDuplicate,
    message: 'This secret name is already used in secrets',
  },
  {
    validator: isValueArrayNotDuplicate,
    message: 'This secret name already exists',
  },
  {
    validator: isValueNotLong(maxSecretNameLength),
    message: 'The secret name is too long',
  },
  {
    validator: isValueNotValidSymbol(/^[a-zA-Z0-9._\-*]+$/),
    message: 'The secret name contains not valid symbol',
  },
]
